<template>
    <div class="footer">
        <div>Copyright © 2025 Fuyan Information Technology Co., Ltd. All Rights Reserved. <a href="https://beian.miit.gov.cn">浙ICP备2023010987号-3</a></div> 
        <div>版权所有：杭州符言信息科技有限公司&nbsp;&nbsp;<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007455">浙公网安备 33010502007455号</a></div>   
    </div>
</template>
<script>
export default {
    name:'Footer',
}
</script>
<style scoped lang="less">
    .footer{
        padding:38px 0 37px;
        position: absolute;
        bottom:0;
        width:100%;
        left:0;
        font-size: 13px;
        color: #FFFFFF;
        background:#060508;
        z-index: 9;
        border-top:1px solid #060508;
    }
    .footer div:first-child{
        letter-spacing: 0.37px;
        text-align: center;
        line-height: 18px;
    }
    .footer div:last-child{
        letter-spacing: 0.37px;
        text-align: center;
        line-height: 18px;
        margin-top: 9px;
    }
    .footer a{
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/layout/footer.vue